import { type PricingGroupVariant } from './pricingGroupVariant'
import { MembershipsV1Currency, MembershipsV1PlatformId } from '@sdk/Api'
import { getContext, setContext } from 'svelte'

const pricingContextKey = Symbol('pricing')

interface PricingContext {
	integration: MembershipsV1PlatformId
	inApp: boolean
	inModal: boolean
	lockedCurrency: MembershipsV1Currency | null
	groupHrefFn: (slug: string) => string
	variant: PricingGroupVariant
}

export function setPricingContext(context: PricingContext) {
	setContext<PricingContext>(pricingContextKey, context)
}

export function getPricingContext() {
	return getContext<PricingContext>(pricingContextKey)
}
